export function generateRandomSlug(length: number = 12): string {
  const chars = 'bcdfghjklmnpqrstvwxyz23456789';
  let result = '';

  for (let i = 0; i < length; i++) {
    const idx = Math.floor(Math.random() * chars.length);
    result += chars[idx];
  }

  return result;
}
